import React from "react";
import { C, NAV_LINKS } from "../constants";
import { P, Btn } from "./UI";

export default function Footer({ setPage }) {
  const go = (p) => { setPage(p); window.scrollTo({ top: 0 }); };

  const services = [
    "Video Production", "Ad Commercials", "Social Media",
    "Brand Films", "Fashion Shoots", "Food Photography",
  ];

  const socials = ["IN", "YT", "FB", "LI"];

  return (
    <footer style={{ background: C.black, color: C.white, padding: "80px clamp(20px, 7vw, 120px) 40px" }}>
      <div className="tp-footer-grid">
        {/* Brand */}
        <div>
          <div style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 900, fontSize: 22, color: C.white, letterSpacing: 1, marginBottom: 4 }}>
            THARAGAI
          </div>
          <div style={{ fontFamily: "'Poppins', sans-serif", fontSize: 9, color: C.muted, letterSpacing: 5, marginBottom: 22 }}>
            PRODUCTIONS
          </div>
          <P size="sm" color="rgba(255,255,255,0.4)" style={{ maxWidth: 270, lineHeight: 1.9 }}>
            Chennai's storytelling-driven production house. We craft cinematic content that connects emotionally and converts commercially.
          </P>
          <div style={{ marginTop: 24, display: "flex", gap: 8 }}>
            {socials.map((s) => (
              <span
                key={s}
                style={{
                  width: 34, height: 34,
                  border: "1px solid rgba(255,255,255,0.12)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontFamily: "'Montserrat', sans-serif", fontSize: 9, fontWeight: 700,
                  color: "rgba(255,255,255,0.4)", cursor: "pointer",
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = C.accent; e.currentTarget.style.color = C.accent; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.12)"; e.currentTarget.style.color = "rgba(255,255,255,0.4)"; }}
              >
                {s}
              </span>
            ))}
          </div>
        </div>

        {/* Nav */}
        <div>
          <div style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: 11, color: "rgba(255,255,255,0.35)", letterSpacing: 3, textTransform: "uppercase", marginBottom: 22 }}>
            Navigate
          </div>
          {NAV_LINKS.map((l) => (
            <button
              key={l.page} onClick={() => go(l.page)}
              style={{ display: "block", background: "none", border: "none", cursor: "pointer", fontFamily: "'Poppins', sans-serif", fontSize: 14, color: "rgba(255,255,255,0.45)", padding: "5px 0", textAlign: "left", transition: "color 0.2s" }}
              onMouseEnter={(e) => e.currentTarget.style.color = C.white}
              onMouseLeave={(e) => e.currentTarget.style.color = "rgba(255,255,255,0.45)"}
            >
              {l.label}
            </button>
          ))}
        </div>

        {/* Services */}
        <div>
          <div style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: 11, color: "rgba(255,255,255,0.35)", letterSpacing: 3, textTransform: "uppercase", marginBottom: 22 }}>
            Services
          </div>
          {services.map((s) => (
            <div key={s} style={{ fontFamily: "'Poppins', sans-serif", fontSize: 13, color: "rgba(255,255,255,0.35)", padding: "5px 0" }}>{s}</div>
          ))}
        </div>

        {/* Contact */}
        <div>
          <div style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: 11, color: "rgba(255,255,255,0.35)", letterSpacing: 3, textTransform: "uppercase", marginBottom: 22 }}>
            Contact
          </div>
          <div style={{ fontFamily: "'Poppins', sans-serif", fontSize: 14, color: "rgba(255,255,255,0.55)", marginBottom: 8 }}>
            hello@tharagaiproduction.com
          </div>
          <div style={{ fontFamily: "'Poppins', sans-serif", fontSize: 14, color: "rgba(255,255,255,0.35)", marginBottom: 28 }}>
            Chennai, Tamil Nadu, India
          </div>
          <Btn variant="solid" onClick={() => go("contact")} style={{ width: "100%", justifyContent: "center" }}>
            Start a Project
          </Btn>
        </div>
      </div>

      <div style={{ borderTop: "1px solid rgba(255,255,255,0.07)", paddingTop: 26, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 10, marginTop: 64 }}>
        <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.2)" }}>
          &copy; 2025 Tharagai Productions. All Rights Reserved.
        </span>
        <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.15)" }}>
          Video Production · Chennai · Tamil Nadu · India
        </span>
      </div>
    </footer>
  );
}
